import { SHOW_MODAL, HIDE_MODAL } from 'actions/modalActions';

export default function (state = null, action = null) {
	switch (action.type) {
		case SHOW_MODAL:
			return action;
		case HIDE_MODAL:
			return null;
		default:
			return state;
	}
}
